import { DELETE_CORRECT_ITEM, GET_CORRECT_ITEM, UPDATE_CORRECT_ITEM } from "../../ActionType/ActionType";

const initState = {
    loading: false,
    items : [],
    pagination : null,
    prevPage : null,
}

export const correctionReducer=(state=initState, action)=>{
    switch (action.type) {

        case GET_CORRECT_ITEM.REQUEST:
           return state = {...state, loading : true}

        case GET_CORRECT_ITEM.SUCCESS:
            let toPush = []
            action.Items.forEach(item => {
                const exist =   state.items.find(e => e.id === item.id)
                if(!exist){
                    toPush.push(item)
                }           
            })
        return state = {...state, loading : false, pagination : action.pagination, items : [...state.items, ...toPush]}

        case GET_CORRECT_ITEM.FAILURE:
            return state = {...state, loading : false}

        case DELETE_CORRECT_ITEM.SUCCESS:
            let rest = state.items.filter(item => item.id !== action.removeId)
           return state = {...state, loading : false, items : rest}


        case UPDATE_CORRECT_ITEM.SUCCESS:
            let restupdate = state.items.filter(item => item.id !== action.updateItem.id)
                        if(action.updateItem.IsProductValidated === false){
                restupdate.push(action.updateItem)
            }
            restupdate.sort((a, b)=>{
                if(a.Barcode < b.Barcode) return -1
                if(a.Barcode > b.Barcode) return 1
                return 0;
            })
            return state = {...state, loading : false, items : restupdate}

        default: return state;
    }
}